import { apiClient, unwrap } from './client';

import type {
  ApiResponse,
  GeneratedPractice,
  MistakeFlatItem,
  MistakeNotebook,
  MySubmission,
  PracticeResult,
  RedoHistoryItem,
  RedoResult,
  StudentReport,
} from '@/types';

export async function getMistakes(): Promise<MistakeNotebook> {
  const response = await apiClient.get<ApiResponse<MistakeNotebook>>('/student/mistakes');
  return unwrap(response);
}

export async function getStudentReport(): Promise<StudentReport> {
  const response = await apiClient.get<ApiResponse<StudentReport>>('/student/report');
  return unwrap(response);
}

export async function getMySubmissions(): Promise<MySubmission[]> {
  const response = await apiClient.get<ApiResponse<MySubmission[]>>('/student/submissions');
  return unwrap(response);
}

/** 收藏 / 取消收藏一道错题 */
export async function toggleMistakeFavorite(
  submissionId: number,
  evidenceId: string,
): Promise<{ favorited: boolean }> {
  const response = await apiClient.post<ApiResponse<{ favorited: boolean }>>(
    '/student/mistakes/favorite',
    { submission_id: submissionId, evidence_id: evidenceId },
  );
  return unwrap(response);
}

/** 我的收藏错题列表 */
export async function getFavoriteMistakes(): Promise<MistakeFlatItem[]> {
  const response = await apiClient.get<ApiResponse<MistakeFlatItem[]>>(
    '/student/mistakes/favorites',
  );
  return unwrap(response);
}

/** 错题重做：提交新作答并获得 AI 批阅 */
export async function redoMistake(
  submissionId: number,
  evidenceId: string,
  content: string,
): Promise<RedoResult> {
  const response = await apiClient.post<ApiResponse<RedoResult>>('/student/mistakes/redo', {
    submission_id: submissionId,
    evidence_id: evidenceId,
    content,
  });
  return unwrap(response);
}

/** 错题重做历史 */
export async function getRedoHistory(): Promise<RedoHistoryItem[]> {
  const response = await apiClient.get<ApiResponse<RedoHistoryItem[]>>(
    '/student/mistakes/redos',
  );
  return unwrap(response);
}

/** 薄弱知识点专项练习（AI 生成） */
export async function generatePractice(
  knowledgePoint: string,
): Promise<GeneratedPractice> {
  const response = await apiClient.post<ApiResponse<GeneratedPractice>>(
    '/student/mistakes/practice',
    { knowledge_point: knowledgePoint },
  );
  return unwrap(response);
}

/** 提交专项练习答案并获得 AI 批改 */
export async function submitPractice(
  practiceId: number,
  answers: string[],
): Promise<PracticeResult> {
  const response = await apiClient.post<ApiResponse<PracticeResult>>(
    `/student/mistakes/practice/${practiceId}/submit`,
    { answers },
  );
  return unwrap(response);
}
